import { validateFields } from './validation';
import { runAdditionalValidation } from './additional-field-validation';
export const getFieldErrors = async (fieldsToValidate, form, isRemoveFalsyValuesEnabled, addressTemplates, externalData, validationMode) => {
    const formValues = fieldsToValidate.reduce((acc, field) => setValue(acc, field.path, field.value), {});
    const result = await validateFields(form, formValues, isRemoveFalsyValuesEnabled, addressTemplates, validationMode);
    const _errors = result?.errors || [];
    const additionalErrors = runAdditionalValidation({
        form,
        values: formValues,
        externalData,
    });
    const allErrors = mergeErrors({ errors: _errors, additionalErrors });
    const fieldErrors = allErrors.filter((error) => findErrorByNormalizedPath(fieldsToValidate, error.errorPath));
    return fieldErrors;
};
export const findErrorByNormalizedPath = (fieldsToValidate, errorPath) => {
    const path = errorPath.split('/').length > 2 ? errorPath.split('/').at(0) : errorPath;
    return !!fieldsToValidate.find((field) => path === field.path);
};
function setValue(object, path, value) {
    const delimiter = '/';
    const decomposedPath = path.split(delimiter);
    const base = decomposedPath[0];
    if (base === undefined) {
        return object;
    }
    if (!object.hasOwnProperty(base)) {
        object[base] = {};
    }
    value =
        decomposedPath.length <= 1
            ? value
            : setValue(object[base], decomposedPath.slice(1).join(delimiter), value);
    return {
        ...object,
        [base]: value,
    };
}
export const mergeErrors = ({ errors, additionalErrors, }) => {
    const errorsToAdd = [];
    if (additionalErrors) {
        Object.keys(additionalErrors).forEach((fieldTarget) => {
            const errorExists = errors.find((error) => error.errorPath === fieldTarget);
            if (!errorExists) {
                errorsToAdd.push(additionalErrors[fieldTarget]);
            }
        });
    }
    return [...errors, ...errorsToAdd];
};
//# sourceMappingURL=get-field-errors.js.map